import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks, businessInfo } from '../../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-[7.6923%]">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="/logo192.png" 
              alt="NOZEN FLASHER Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-white font-semibold text-xl tracking-tight">
              {businessInfo.name}
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.href)}
                className="text-[#4D4D4D] hover:text-white text-lg font-normal transition-colors duration-300"
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href={`tel:${businessInfo.phone}`}
              className="flex items-center gap-2 text-white hover:text-[#00FFD1] transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span className="font-medium">{businessInfo.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-md border-t border-white/10">
          <nav className="flex flex-col py-4 px-5">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.href)}
                className="text-white/80 hover:text-[#00FFD1] text-lg py-3 text-left transition-colors"
              >
                {link.label}
              </button>
            ))}
            <a
              href={`tel:${businessInfo.phone}`}
              className="flex items-center gap-2 text-[#00FFD1] py-3 mt-2 border-t border-white/10"
            >
              <Phone className="w-5 h-5" />
              <span className="font-medium">{businessInfo.phone}</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
